import { io, Socket } from 'socket.io-client';
import { useAuthStore } from '../store/auth.store';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3100';

let socket: Socket | null = null;

/** Singleton Socket.IO authentifié au token courant. */
export const getSocket = (): Socket => {
  if (socket && socket.connected) return socket;
  const token = useAuthStore.getState().accessToken;
  socket = io(SOCKET_URL, {
    transports: ['websocket'],
    autoConnect: true,
    auth: { token },
    reconnection: true,
    reconnectionAttempts: 8,
    reconnectionDelay: 1500,
  });
  return socket;
};

export const disconnectSocket = (): void => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
